import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import {
  PersonasJuridica,
  RPEPersonaJuridica
} from './entity-personas-juridica.model';

@Injectable({
  providedIn: 'root'
})
export class PersonasJuridicaService {
  url: string;
  token: string;
  endpoint = 'personasJuridica';
  endpointRPE = 'rpePersonasJuridica';

  constructor(private http: HttpClient) { }

  getPersonasJuridica(): Observable<PersonasJuridica[]> {
    return this.http.get<PersonasJuridica[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addPersonaJuridica(
    personasJudirica: PersonasJuridica
  ): Observable<PersonasJuridica> {
    return this.http.post<PersonasJuridica>(`${this.url}/${this.endpoint}/`, {
      ...personasJudirica
    });
  }

  addRPEPersonaJuridica(
    rpePersonasJudirica: RPEPersonaJuridica
  ): Observable<RPEPersonaJuridica> {
    return this.http.post<RPEPersonaJuridica>(
      `${this.url}/${this.endpointRPE}/`,
      {
        ...rpePersonasJudirica
      }
    );
  }

  changePersonaJuridica(p: PersonasJuridica): Observable<PersonasJuridica> {
    return this.http.patch<PersonasJuridica>(
      `${this.url}/${this.endpoint}/${p.id}/`,
      {
        ...p,
      }
    );
  }

  changeRPEPersonaJuridica(p: RPEPersonaJuridica): Observable<RPEPersonaJuridica> {
    return this.http.patch<RPEPersonaJuridica>(
      `${this.url}/${this.endpointRPE}/${p.persona_juridica.id}/`,
      {
        ...p,
      }
    );
  }

  deletePersonaJuridica(p: PersonasJuridica): Observable<PersonasJuridica> {
    return this.http.delete<PersonasJuridica>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }

  // Mock
  getPersonasJuridicaMock(): Observable<PersonasJuridica[]> {
    return of(this.listaPersonasJuridicas);
  }

  listaPersonasJuridicas: PersonasJuridica[] = [
    {
      id: 1,
      denominacion_social: 'Henderson Hermanos',
      nombre_fantasia: 'Tienda Inglesa',
      rut: '1234567',
      bps: 342323123,
      certificado_notarial: null,
      naturaleza_juridica_id: 1 // NaturalezaJuridica
    },
    {
      id: 2,
      denominacion_social: 'Mosca',
      nombre_fantasia: 'Jugueteria',
      rut: '567890',
      bps: 433333,
      certificado_notarial: null,
      naturaleza_juridica_id: 1 // NaturalezaJuridica
    },
    {
      id: 3,
      denominacion_social: 'Tata',
      nombre_fantasia: 'Supermercado',
      rut: '41113',
      bps: 7774,
      certificado_notarial: null,
      naturaleza_juridica_id: 1 // NaturalezaJuridica
    },
    {
      id: 4,
      denominacion_social: 'Devoto',
      nombre_fantasia: 'Market',
      rut: '33322',
      bps: 3902,
      certificado_notarial: null,
      naturaleza_juridica_id: 1 // NaturalezaJuridica
    }
  ];
}
